import { AxiosRequestConfig } from 'axios'

import { INNER_STORE } from './constants'
import { get } from './inner-store'

const requestInterceptor = (
  config: AxiosRequestConfig,
): AxiosRequestConfig => {
  const authData = get(INNER_STORE.auth)

  if (authData?.access_token !== undefined) {
    config.headers = {
      ...config.headers,
      ...{ Authorization: `Bearer ${authData.access_token}` },
    }
  }

  return config
}

export { requestInterceptor }
